import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'y42-canvas-context-menu-toolbar',
  templateUrl: './canvas-context-menu-toolbar.component.html',
  styleUrls: ['./canvas-context-menu-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CanvasContextMenuToolbarComponent {
  @Input()
  position?: { x: number; y: number };
}
